import './styles.css';
import { AppController } from './ui/AppController';

const app = new AppController();
app.initialize();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(new URL('./service-worker.js', document.baseURI));
  });
}
